import { render, staticRenderFns } from "./BCXInfoBanner.vue?vue&type=template&id=2c021856&scoped=true"
import script from "./BCXInfoBanner.vue?vue&type=script&lang=ts"
export * from "./BCXInfoBanner.vue?vue&type=script&lang=ts"
import style0 from "./BCXInfoBanner.vue?vue&type=style&index=0&id=2c021856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c021856",
  null
  
)

export default component.exports